import { useLocation, useNavigate } from "react-router-dom";
import SuccessScreen from "../../Common/SuccessScreen";

export const CompleteBuyerOnboarding = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const {
    isInfluencer,
    isManualKyc,
    isSupplierApprovalRequired,
    message,
    origin,
    billInfo,
    role,
  } = location.state || {};

  const approvalRequired = !!isSupplierApprovalRequired;
  const isDp = origin === "dp_stp";
  const isStpOrigin = origin === "inventory_stp" || isDp;
  const checkoutPath = isDp ? "/dp/checkout" : "/inventory/checkout";
  const addressInfoPath = isDp
    ? "/dp-shiping-info"
    : "/inventory/selected-ship-to-party";

  const title =
    isInfluencer && !isManualKyc
      ? "Successfully Onboarded & e-KYC Verified!"
      : "Onboarded Successfully";

  const filledButtonAction = () => {
    if (isInfluencer) {
      if (isStpOrigin) {
        return navigate(checkoutPath, {
          state: {
            bill_info: billInfo,
            influencerTabSelected: true,
            selectedRole: role,
          },
        });
      }
      return navigate("/inventory");
    }

    
    if (isStpOrigin) {
      if (approvalRequired) return navigate("/inventory");
      return navigate(addressInfoPath, {
        state: {
          buyerDetails: billInfo,
          influencerTabSelected: false,
          selectedRole: role,
        },
      });
    }
    return navigate(approvalRequired ? "/my-network" : "/inventory");
  };
  const outlinedButtonAction = () => navigate("/");

  const filledButtonLabel =
    !isInfluencer && !isStpOrigin && approvalRequired
      ? "My Network"
      : "Sell Products";

  return (
    <SuccessScreen
      title={title}
      subtitle={message}
      filledButtonLabel={filledButtonLabel}
      filledButtonAction={filledButtonAction}
      OutlinedButtonLabel="Home"
      OutlinedButtonAction={outlinedButtonAction}
      buttonContainerWidth={{ xs: "100%", sm: "565px" }}
    />
  );
};

export default CompleteBuyerOnboarding;
